export const theme = {
  colors: {
    primary: '#0F2540',
    primaryDark: '#0A1A2E',
    accent: '#1F8E8E',
    accentSoft: '#E6F2F2',
    light: '#F6F8FB',
    surface: '#FFFFFF',
    border: '#E2E8F0',
    dark: '#0F1A2A',
    text: '#334155',
    muted: '#64748B',
    background: '#FFFFFF',
    success: '#2F855A',
    warning: '#B7791F',
    danger: '#C53030',
  },
  fonts: {
    primary: "'Inter', 'Poppins', sans-serif",
    secondary: "'Inter', 'Montserrat', sans-serif",
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  shadows: {
    small: '0 1px 2px rgba(15, 37, 64, 0.06), 0 1px 3px rgba(15, 37, 64, 0.04)',
    medium: '0 4px 14px rgba(15, 37, 64, 0.08)',
    large: '0 12px 32px rgba(15, 37, 64, 0.10)',
  },
};
